import React, { useState, useEffect } from "react";
import req from "../utilities/request-utility";

const useDataEndpoint = (endpoint) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);

    req()(endpoint)
      .then((res) => {
        setData(res.data)
        setLoading(false);
      })
      .catch((err) => {
        setError(err);
        setLoading(false);
      });
  }, [endpoint]);

  return { data, loading, error };
};

export default useDataEndpoint;
